import { __decorate, __metadata } from 'tslib';
import { Storage } from '@ionic/storage';
import { Injectable, NgModule } from '@angular/core';
import { SpeViewNCellPhoneRecharge, SpeJCashOut, UiPxRechargePhoneModule } from '@wlp/ui-px-recharge-phone';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { UiBsOauthModule } from '@wlp/ui-bs-oauth';

let RechargeService = class RechargeService {
    constructor(speViewNCellPhoneRecharge, speJCashOut, storage, formBuilder) {
        this.speViewNCellPhoneRecharge = speViewNCellPhoneRecharge;
        this.speJCashOut = speJCashOut;
        this.storage = storage;
        this.formBuilder = formBuilder;
    }
    createFormNumber() {
        return this.formBuilder.group({
            phoneNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(15)
            ])),
            operator: new FormControl('', Validators.compose([
                Validators.required,
            ])),
        });
    }
    getOperators(uuidAccountPayment, phoneNumber) {
        let result = this.formatNumber(phoneNumber);
        return this.speViewNCellPhoneRecharge.getOperators(uuidAccountPayment, result.number, result.ddd);
    }
    checkRecharge(uuidAccountPayment, receiptId) {
        return this.speViewNCellPhoneRecharge.checkRecharge(uuidAccountPayment, receiptId);
    }
    consultProductsByOperator(uuidAccountPayment, phoneNumber, ddd, operatorId, historicId, nsu) {
        return this.speViewNCellPhoneRecharge.consultProductsByOperator(uuidAccountPayment, phoneNumber, ddd, operatorId, historicId, nsu);
    }
    setNumberStorage(ddd, phone, operatorDescription, code) {
        this.storage.set('lastNumberRecharge', { ddd, phone, operatorDescription, code });
    }
    getNumberStorage() {
        this.storage.get('lastNumberRecharge')
            .then(res => {
            if (res != null)
                return res;
        });
    }
    formatNumber(phone) {
        let arryPhone = phone.split(' ');
        let ddd = arryPhone[0].substr(1, 2);
        let number = arryPhone[1].replace('-', '');
        return { ddd, number };
    }
    paymentRecharge(body) {
        return this.speJCashOut.paymentRecharge(body);
    }
};
RechargeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeViewNCellPhoneRecharge,
        SpeJCashOut,
        Storage,
        FormBuilder])
], RechargeService);

let UiBsRechargePhoneModule = class UiBsRechargePhoneModule {
};
UiBsRechargePhoneModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule,
            UiPxRechargePhoneModule
        ],
        providers: [
            RechargeService
        ]
    })
], UiBsRechargePhoneModule);

export { RechargeService, UiBsRechargePhoneModule };
//# sourceMappingURL=wlp-ui-bs-recharge-phone.js.map
